import { getAppEnv } from '@/lib/env';

/**
 * Environment marker shown beside the logo in the Home header so testers
 * can tell the QA/DEV app from PROD at a glance. Renders nothing in a
 * production build (fail-safe: unknown env counts as prod).
 * "QA"/"DEV" are environment codes, not end-user copy — no i18n entry.
 */
const EnvLabel = () => {
  const env = getAppEnv();
  if (env === 'prod') return null;

  return (
    <span
      data-testid="env-label"
      className="tw:caption tw:rounded tw:bg-yellow-primary tw:px-1.5 tw:py-0.5 tw:font-bold tw:uppercase tw:text-dark-primary"
    >
      {env === 'qa' ? 'QA' : 'DEV'}
    </span>
  );
};

export default EnvLabel;
